import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.timeValue,
      "color": _vm.color,
      "outlined": _vm.outlined,
      "filled": _vm.filled,
      "label": _vm.label,
      "type": "number",
      "min": "1",
      "required": ""
    },
    on: {
      "input": _vm.handleValueChange
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "value": _vm.timeUnit,
      "color": _vm.color,
      "outlined": _vm.outlined,
      "filled": _vm.filled,
      "items": _vm.unitOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.rules.fields.unit'),
      "required": ""
    },
    on: {
      "input": _vm.handleUnitChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };